import { useEffect } from 'react';
import type { Preferences } from '@keep/shared';
import { useMediaQuery } from './use-media-query';

/** Applique le thème (clair / sombre / système) sur <html>. */
export function useApplyTheme(theme: Preferences['theme'] | undefined) {
  const systemDark = useMediaQuery('(prefers-color-scheme: dark)');
  const dark = theme === 'dark' || ((theme ?? 'system') === 'system' && systemDark);
  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark);
    document.documentElement.style.colorScheme = dark ? 'dark' : 'light';
  }, [dark]);
}
